// extracted by mini-css-extract-plugin
export default {"wrapper":"hx-z","button":"ix-z","alternate":"jx-z","disabled":"kx-z","paymentWarning":"lx-z","fadeIn":"mx-z"};